import ReactDOM from "react-dom";

function load(selector, view) {
  const nodes = [...document.querySelectorAll(selector)];
  if (!nodes) return null;

  return nodes.map((node) => {
    const config =
      node.config ||
      (node.dataset.config.indexOf("{") !== -1
        ? JSON.parse(node.dataset.config)
        : window[node.dataset.config]);

    return ReactDOM.createPortal(view(config, node), node);
  });
}

export default {
  load,
};



// WEBPACK FOOTER //
// ./src/utils/dynamicPortal.js